module.exports = __webpack_public_path__ + "media/images/logo-7d054d444f6369acd44e039f7a8b11c0.svg";